import { createContext, useEffect, useState } from 'react';
import MainSection from './MainSection';
import { useLocation } from 'react-router';
import Landing from './landing/Landing';
import Guntechchat from './guntechchatbot/Guntechchat';
import JobDescriptionRoute from './guntechjobdesc/Job_Description/JobDescriptionRoute';
import GuntechlinkedinPost from './guntechlinkedin/GuntechlinkedinPost';
import PrescriptionDectRoute from './prescriptionDetector/PrescriptionDectRoute';
import GuntechSchool from './guntechschoolai/GuntechSchool';
import RecommendationEngineRoute from './recommendation/RecommendationEngineRoute';
import CrawlingChatbotRoute from './guntechcrawchatbot/SecurityConfig/CrawlingChatbotRoute'
import { HelmetProvider } from 'react-helmet-async';
import { alertClasses } from '@mui/material';
import RealEstateRoute from './real-e-state/RealEstateRoute';

export const ContextApi = createContext({
  totalFaces: 0,
  setTotalFaces: () => {}
});
function App() {
  const [totalFaces, setTotalFaces] = useState();
  const value = { totalFaces, setTotalFaces };
  const [showSections, setShowsections] = useState({
    landing: true,
    chatbot: false,
    description: false,
    techpred: false,
    prescription: false,
    linkedin: false,
    lessonplanner : false,
    recommendationengine : false,
    crawlingchatbot : false,
    realestate : false,
  });
  const location = useLocation();
  const [showchatbot, setshowchatbot] = useState(false);
  const { hash, pathname, search } = location;

  useEffect(() => {
    // if (
    //   pathname.includes('aichatbot') ||
    //   pathname.includes('techpred') ||
    //   pathname.includes('jobdescription') ||
    //   pathname.includes('chatbotbase')
    // ) {
    //   setShowsections(true);
    //   setshowchatbot(false);
    // } else {
    //   setShowsections(false);
    //   setshowchatbot(false);
    // }
    // if (pathname.includes('chatbotbase')) {
    //   setshowchatbot(true);
    //   setShowsections(false);
    // } else {
    //   setShowsections(false);
    //   setshowchatbot(false);
    // }

    switch (true) {
      case pathname.includes('aichatbot'):
        setShowsections({
          landing: false,
          chatbot: false,
          aichatbot: true,
          description: false,
          techpred: false,
          prescription: false,
          linkedin: false,
          lessonplanner: false,
          recommendationengine : false,
          crawlingchatbot : false,
          realestate : false
        });
        break;
      case pathname.includes('techpred'):
        setShowsections({
          landing: false,
          chatbot: false,
          aichatbot: false,
          description: false,
          techpred: true,
          prescription: false,
          linkedin: false,
          lessonplanner: false,
          recommendationengine : false,
          crawlingchatbot : false,
          realestate : false
        });

        break;
      case pathname.includes('chatbotbase'):
        setShowsections({
          landing: false,
          chatbot: true,
          aichatbot: false,
          description: false,
          techpred: false,
          prescription: false,
          linkedin: false,
          lessonplanner: false,
          recommendationengine : false,
          crawlingchatbot : false,
          realestate : false
        });

        break;
      case pathname.includes('jobdescription'):
        setShowsections({
          landing: false,
          chatbot: false,
          aichatbot: false,
          description: true,
          techpred: false,
          prescription: false,
          linkedin: false,
          lessonplanner: false,
          recommendationengine : false,
          crawlingchatbot : false,
          realestate : false
        });
        break;
      case pathname.includes('crawling'):
        setShowsections({
          landing: false,
          chatbot: false,
          aichatbot: false,
          description: false,
          techpred: false,
          prescription: false,
          linkedin: false,
          lessonplanner: false,
          recommendationengine : false,
          crawlingchatbot : true,
          realestate : false
        });
        break;
      case pathname.includes('prescription'):
        setShowsections({
          landing: false,
          chatbot: false,
          aichatbot: false,
          description: false,
          techpred: false,
          prescription: true,
          linkedin: false,
          lessonplanner: false,
          recommendationengine : false,
          crawlingchatbot : false,
          realestate : false
        });
        break;
      case pathname.includes('linkedinpost'):
        setShowsections({
          landing: false,
          chatbot: false,
          aichatbot: false,
          description: false,
          techpred: false,
          prescription: false,
          linkedin: true,
          lessonplanner: false,
          recommendationengine : false,
          crawlingchatbot : false,
          realestate : false
        });
        break;
      case pathname.includes('recommendation'):
        setShowsections({
          landing: false,
          chatbot: false,
          aichatbot: false,
          description: false,
          techpred: false,
          prescription: false,
          linkedin: false,
          recommendationengine : true,
          crawlingchatbot : false,
          realestate : false,
          lessonplanner: false,
        });
        break;
      case pathname.includes('lessonplanner'):
        setShowsections({
          landing: false,
          chatbot: false,
          aichatbot: false,
          description: false,
          techpred: false,
          prescription: false,
          linkedin: false,
          lessonplanner: true,
          crawlingchatbot : false,
          recommendationengine : false,
          realestate : false,
        });
        break;  
      case pathname.includes('realestate'):
        setShowsections({
          landing: false,
          chatbot: false,
          aichatbot: false,
          description: false,
          techpred: false,
          prescription: false,
          linkedin: false,
          lessonplanner: false,
          crawlingchatbot : false,
          recommendationengine : false,
          realestate : true,
        });
        break;  
      default:
        setShowsections({
          landing: true,
          chatbot: false,
          aichatbot: false,
          description: false,
          techpred: false,
          prescription: false,
          linkedin: false,
          lessonplanner: false,
          recommendationengine : false,
          crawlingchatbot : false,
          realestate : false,
        });
        break;
    }
  }, [pathname]);
  return (
    <HelmetProvider>
    <ContextApi.Provider value={value}>
      {showSections.techpred && <MainSection />}
      {showSections.aichatbot && <MainSection />}
      {showSections.description && <JobDescriptionRoute />}
      {showSections.landing && <Landing />}
      {showSections.chatbot && <Guntechchat />}
      {showSections.prescription && <PrescriptionDectRoute />}
      {showSections.linkedin && <GuntechlinkedinPost />}
      {showSections.lessonplanner && <GuntechSchool/>}
      {showSections.recommendationengine && <RecommendationEngineRoute /> }
      {showSections.crawlingchatbot && <CrawlingChatbotRoute/> }
      {showSections.realestate && <RealEstateRoute/>}
    </ContextApi.Provider>
    </HelmetProvider>
  );
}
export default App;
